<template>
  <div class="mine">
    <div class="banner">
      <div class="item-banner">
        <img :src="avatar" alt="" />
        <div class="info">
          <span>{{name}}</span>
          <span class="phone">{{phone ? phone : '请先实名'}}</span>
          <span class="phone" v-if="area_name">{{area_name}}</span>
        </div>
        <div class="renzheng_btn" @click="toAttestation" v-if="is_bind == 0">
          实名认证 >
        </div>
      </div>
    </div>

    <div class="line" @click="toMyReport" v-if="is_bind == 1 && is_inspector == 0">
      <div class="item-line">
        <div class="line-left">
          <img src="../../assets/images/mine/1.png" alt="" />
          我的事件工单
        </div>
        <div class="line-right">
          <img src="../../assets/images/mine/jiantou.png" alt="" />
        </div>
      </div>
    </div>
    <div class="line" @click="toMyWorkOrder" v-if="is_bind == 1 && is_inspector == 1">
      <div class="item-line">
        <div class="line-left">
          <img src="../../assets/images/mine/2.png" alt="" />
          我的交办单
        </div>
        <div class="line-right">
          <img src="../../assets/images/mine/jiantou.png" alt="" />
        </div>
      </div>
    </div>
    <!-- 存档 -->
    <div class="line" @click="toMyFile" v-if="is_bind == 1 && is_inspector == 1">
      <div class="item-line">
        <div class="line-left">
          <img src="../../assets/images/mine/file-icon.png" alt="" />
          我的存档
        </div>
        <div class="line-right">
          <img src="../../assets/images/mine/jiantou.png" alt="" />
        </div>
      </div>
    </div>
    <tabber></tabber>
  </div>
</template>

<script>
import tabber from "@/components/tabber/tabber.vue";
import { Toast } from "vant";
import {  } from "./api";
export default {
  name: "Mine",
  components: {
    tabber,
  },
  data() {
    return {
      avatar: this.$store.state.user.userInfo.avatar,
      name: this.$store.state.user.userInfo.name,
      is_bind: this.$store.state.user.userInfo.is_bind,
      is_inspector: this.$store.state.user.userInfo.is_inspector,
      phone: this.$store.state.user.userInfo.phone,
      area_name: this.$store.state.user.userInfo.area_name,
      days:'',
    };
  },
  created() {
    this.init();
  },
  methods: {
    toAttestation() {
        this.$router.push("/attestation");
    },
    toMyReport(){
      this.$router.push("/myEventOrder");
    },
    toMyWorkOrder(){
      this.$router.push("/myWorkOrder");
    },
    toMyFile() {
      this.$router.push("/myFile");
    },
    init() {
      let params = {
        match_id: 2,
        token: window.localStorage.getItem("token"),
      }
      // getMyStatistics(params).then( res=>{
      //     this.days = res.data.study_num
      // })
    },
  },
};
</script>

<style scoped lang="less">
.mine {
  width: 100%;
  overflow: hidden;
  .banner {
    width: 100%;
    height: 3rem;
    background-image: url("../../assets/images/mine/banner1.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 0.01rem;
    .item-banner {
      position: relative;
      margin: 0.8rem 0 0 0.4rem;
      color: #fff;
      letter-spacing: 0.02rem;
      img {
        width: 1.33rem;
        height: 1.33rem;
        border-radius: 50%;
        vertical-align: -0.8rem;
        margin-right: 0.4rem;
      }
      .info{
        display: inline-block;
        height: 100%;
        line-height: 100%;
        position: absolute;
        top: 0.3rem;
        span{
          display: block;
        }
        .phone{
          margin-top: 0.2rem;
        }
      }
      .renzheng_btn{
        width: 1.875rem;
        height: .625rem;
        font-size: 0.3rem;
        font-weight: 500;
        position: absolute;
        top: 0.2rem;
        right: 0rem;
        display: inline-block;
        background: #FFB342;
        text-align: center;
        line-height: .625rem;
        border-top-left-radius: 0.3rem;
        border-bottom-left-radius: 0.3rem;
      }
    }
  }
  .img-con {
    width: 100%;
    height: 2.6rem;
    padding: 0 0.3rem;
    margin-bottom: 0.24rem;
    // background-image: url("../../assets/images/home/bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    /deep/.swiper {
      width: 100%;
      height: 3.35rem !important;
      position: relative;
      top: 0.8rem;
    }
    /deep/ img {
      width: 100%;
      height: 3.35rem !important;
      display: block;
      border-radius: 0.08rem;
    }
  }
  .line {
    width: calc(100% - 0.4rem);
    height: 1rem;
    margin: 0 auto;
    position: relative;
    .item-line {
      width: 100%;
      height: 1rem;
      padding: 0 0.2rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #fff;
      border-radius: 0.1rem;
      margin-top: 0.2rem;
      .line-left {
        line-height: 1rem;
        img {
          width: 0.44rem;
          height: 0.44rem;
          vertical-align: -0.1rem;
          margin-right: 0.2rem;
        }
      }
      .line-right {
        img {
          width: 0.12rem;
          height: 0.22rem;
        }
      }
    }
  }
}
</style>